import { useAuth } from '../../context/AuthContext';
import { postLoginPath } from '../../config/rolePermissions';

/**
 * Where a visitor who is already signed in goes instead of seeing a sign-in form (a bookmarked
 * /login, the Back button after signing in): the place a fresh sign-in would have led.
 *
 * `null` while there is no session, while the role is still being resolved, and while the page
 * itself is signing someone in (`busy`), because the page navigates on its own in that case.
 *
 * @param {{ returnTo?: string | null, busy?: boolean }} [options]
 * @returns {string | null} a path, or null to show the form
 */
export default function useSignedInTarget({ returnTo = null, busy = false } = {}) {
  const { isAuthenticated, user, staffRole } = useAuth();
  if (!isAuthenticated || !staffRole || busy) return null;
  return postLoginPath({ returnTo, accountRole: user?.role, staffRole });
}
